import axios from "axios";
import { axiosConfig } from "../../config/index";
import {
  APPROVER_ADDED,
  APPROVER_FETCHED,
  SET_APPROVER,
  APPROVER_EDITED,
  APPROVER_DELETED,
} from "../types";

/**
 * Registers a new supervisor/manager as an authorized approver.
 */
export const addApprover = (approverData: any) => (
  dispatch: any,
  getState: any
) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/approvers/addapprover`, approverData, axiosConfig)
      .then((res) => {
        dispatch({
          type: APPROVER_ADDED,
          addedApprover: res.data,
        });
        dispatch(getAllApprovers());
        resolve(true);
      })
      .catch((err) => {
        reject(err.response.data);
      });
  });
};

/**
 * Fetches all registered approvers.
 */
export const getAllApprovers = () => (dispatch: any) => {
  axios
    .get(`/api/approvers/getallapprover`, axiosConfig)
    .then((res) => {
      dispatch({
        type: APPROVER_FETCHED,
        approverData: res.data,
      });
    })
    .catch((err) => {
      console.error(err);
    });
};

export const setApprover = (singleApprover: any) => {
  return {
    type: SET_APPROVER,
    singleApprover,
  };
};

/**
 * Updates an approver's system details (such as location/region scopes).
 */
export const editApprover = (approverId: any, editedApproverData: any) => (
  dispatch: any
) => {
  return new Promise((resolve, reject) => {
    axios
      .put(
        `/api/approvers/updateapprover/${approverId}`,
        editedApproverData,
        axiosConfig
      )
      .then((res) => {
        dispatch({
          type: APPROVER_EDITED,
        });
        dispatch(getAllApprovers());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};

/**
 * Archives/deletes an approver status.
 */
export const deleteApprover = (approverId: any) => (dispatch: any) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/approvers/deleteapprover/${approverId}`, {}, axiosConfig)
      .then((res) => {
        dispatch({
          type: APPROVER_DELETED,
        });
        dispatch(getAllApprovers());
        resolve(res.data);
      })
      .catch((err) => {
        console.error(err);
        reject(err?.response?.data || err);
      });
  });
};
